import { BaseModal, Button } from '@cokitchen/cokitchen-components';
import React, { FC } from 'react';
import { ReactComponent as LogoutIcon } from 'assets/icons/error.svg';

interface LogoutModalProps {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
  itemCount?: number;
}

interface RemoveModalFooterProps {
  onCancel: () => void;
  onConfirm: () => void;
  loading?: boolean;
}

const RemoveModalFooter: FC<RemoveModalFooterProps> = ({ onCancel, onConfirm, loading }) => (
  <div className='flex gap-2'>
    <Button small color='gray' variant='block' className='mx-auto' onClick={onCancel}>
      Cancel
    </Button>
    <Button
      small
      color='primary'
      variant='block'
      className='mx-auto'
      loading={loading}
      onClick={onConfirm}>
      Confirm
    </Button>
  </div>
);

const RemoveModal: FC<LogoutModalProps> = ({
  show,
  onClose,
  onConfirm,
  loading = false,
  itemCount = 0
}) => {
  const isBulkDelete = itemCount > 1;
  const titleText = isBulkDelete
    ? 'Are you sure you want to remove the selected store items'
    : 'Are you sure you want to remove this store item';
  const descriptionText = isBulkDelete
    ? 'This will delete data associated with these store items'
    : 'This will delete data associated with this store item';

  return (
    <BaseModal
      isOpen={show}
      title=''
      description={``}
      titleIconColor='danger'
      onRequestClose={() => onClose()}
      footer={
        <RemoveModalFooter loading={loading} onCancel={() => onClose()} onConfirm={onConfirm} />
      }>
      <div className='flex flex-col justify-center items-center'>
        <LogoutIcon />
        <p className=' py-2'>{titleText}</p>

        <p className='text-sm text-gray-8 text-center'>{descriptionText}</p>
      </div>
    </BaseModal>
  );
};

export default RemoveModal;
